// Theme helper — toggles `dark` class on <html>
const KEY = "verihandi_theme";

export function getTheme() {
  try {
    const t = localStorage.getItem(KEY);
    if (t === "dark" || t === "light") return t;
  } catch { /* ignore */ }
  if (typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches) return "dark";
  return "light";
}

export function applyTheme(t) {
  const root = document.documentElement;
  if (t === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
}

export function toggleTheme() {
  const cur = document.documentElement.classList.contains("dark") ? "dark" : "light";
  const next = cur === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}
